import { FC } from 'react';

import { EBookCoworkingFormFields } from 'shared/components/BookCoworkingFrom/constants';
import { BookCoworkingModal } from 'shared/components/BookCoworkingModal';
import { ShowCoworkingOperatorPhoneButton } from 'shared/components/ShowCoworkingOperatorPhoneButton';
import { ButtonWithAnalyticEvent } from 'shared/containers/ButtonWithAnalyticEvent';
import { useCoworkingWorkplaceCountAsStringSelector } from 'shared/hooks/selectors/coworking/useCoworkingWorkplaceCountSelector';
import { useSelectedCoworkingTypeSelector } from 'shared/hooks/selectors/coworking/useSelectedCoworkingTypeSelector';
import { trackBookingButtonClick } from 'shared/store/analytics/actions/trackBookingButtonClick';

import { getCoworkingOfferTypeFieldInitialState } from './internal/helpers/getCoworkingOfferTypeFieldInitialState';

import * as styles from './CoworkingActionsButtons.css';

export const CoworkingActionsButtons: FC = () => {
  const workplaceCount = useCoworkingWorkplaceCountAsStringSelector();
  const selectedCoworkingType = useSelectedCoworkingTypeSelector();

  return (
    <div className={styles['container']}>
      <div className={styles['phone-button']}>
        <ShowCoworkingOperatorPhoneButton />
      </div>
      <BookCoworkingModal
        formInitialState={{
          [EBookCoworkingFormFields.WorkplaceCount]: {
            errorMessage: null,
            value: workplaceCount,
          },
          [EBookCoworkingFormFields.CoworkingOfferType]: {
            errorMessage: null,
            value: getCoworkingOfferTypeFieldInitialState(selectedCoworkingType),
          },
        }}
      >
        {modalVisibilityState => (
          <div className={styles['book-coworking-button']} data-testid="book-coworking-button-wrapper">
            <ButtonWithAnalyticEvent
              size="XS"
              theme="fill_secondary"
              trackAnalyticEvent={trackBookingButtonClick}
              type="button"
              onClick={modalVisibilityState.setTrue}
            >
              Забронировать
            </ButtonWithAnalyticEvent>
          </div>
        )}
      </BookCoworkingModal>
    </div>
  );
};

CoworkingActionsButtons.displayName = 'CoworkingActionsButtons';
